import { render, staticRenderFns } from "./DossierTable.vue?vue&type=template&id=880323c8"
import script from "./DossierTable.vue?vue&type=script&lang=js"
export * from "./DossierTable.vue?vue&type=script&lang=js"
import style0 from "./DossierTable.vue?vue&type=style&index=0&id=880323c8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports